import { CSSProperties } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { inlineLinkStyle } from '../common/generic/content/texts/inline-link';
import { CONTRIBUTE_MODAL_NAME } from '../common/upright/model/input/contributions/contribution-modal';
import { openModal } from './redux/modules/modal';
import { BouLink, getBouLinkStyle } from '../common/generic/content/texts/bou-link';

const restrictedContentInfoTextPortfolios = <p>Portfolios are only visible to investor and company users.</p>;

export const RestrictedContentUpsellText = (props: { onLinkClick?: () => void }) => {
  const dispatch = useDispatch();
  const openFeedbackModal = () => dispatch(openModal(CONTRIBUTE_MODAL_NAME, { type: 'OPEN_COMMENT' }));

  return (
    <>
      <StyledRequestAccessOrContact
        openContactModal={() => {
          if (props.onLinkClick) {
            props.onLinkClick();
          }
          openFeedbackModal();
        }}
      />
    </>
  );
};

const StyledBouLink = styled(BouLink)`
  font-weight: normal;
  text-decoration: underline;
`;

const ContactFormLink = styled.span`
  ${getBouLinkStyle(true)}
  font-weight: normal;
  text-decoration: underline;
`;

// NOTE: this used to be in not-available-content, but this led to as nasty circular imports issue
// => moved it here to avoid -- JO 2025-03-26
export const RequestAccessOrContact = (props: { openContactModal: () => void; className?: string }) => {
  return (
    <div className={props.className}>
      To get full data access for commercial use, please read more about our subscription options for{' '}
      <StyledBouLink to="/for-investors">investors</StyledBouLink> and{' '}
      <StyledBouLink to="/for-companies">companies</StyledBouLink>, and reach out to us. To request a free community
      license, contact us{' '}
      <ContactFormLink
        onClick={() => {
          props.openContactModal();
        }}
      >
        here
      </ContactFormLink>
      .
    </div>
  );
};

const StyledRequestAccessOrContact = styled(RequestAccessOrContact)`
  margin-top: 1em;
  margin-bottom: 1em;
  max-width: 30em;
  margin-left: auto;
  margin-right: auto;
`;

export const restrictedPortfoliosText = (
  <div>
    {restrictedContentInfoTextPortfolios}
    <RestrictedContentUpsellText />
  </div>
);

export const RestrictedContentTextBrief = (props: { onLinkClick?: () => void; style?: CSSProperties }) => {
  const dispatch = useDispatch();
  const openFeedbackModal = () => dispatch(openModal(CONTRIBUTE_MODAL_NAME, { type: 'OPEN_COMMENT' }));

  return (
    <div style={props.style || { maxWidth: '24rem' }}>
      Available only with subscription. If you'd like to learn more, please{' '}
      <GetInTouchButton
        onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          if (props.onLinkClick) {
            props.onLinkClick();
          }
          openFeedbackModal();
        }}
      >
        click here to send us a message!
      </GetInTouchButton>{' '}
    </div>
  );
};

export const UpgradeSubscriptionTextBrief = (props: { onLinkClick?: () => void; style?: CSSProperties }) => {
  const dispatch = useDispatch();
  const openFeedbackModal = () => dispatch(openModal(CONTRIBUTE_MODAL_NAME, { type: 'OPEN_COMMENT' }));

  return (
    <div style={props.style || { maxWidth: '24rem' }}>
      Your subscription does not include this company. Please{' '}
      <GetInTouchButton
        onClick={() => {
          if (props.onLinkClick) {
            props.onLinkClick();
          }
          openFeedbackModal();
        }}
      >
        contact us
      </GetInTouchButton>{' '}
      if you want to upgrade your subscription.
    </div>
  );
};

export const NotCurrentlyAvailableText = (props: { style?: CSSProperties }) => {
  return <div style={props.style || { maxWidth: '24rem' }}>Not currently available.</div>;
};

export const GetInTouchButton = styled.span`
  font-weight: 700;
  cursor: pointer;
  ${inlineLinkStyle}
  text-decoration: none;
`;
